import {useState} from "react";

/** Fetch privately with the current login; only the PDF bytes enter the viewer. */
export function AgreementPdfButton({storeId,label="View agreement PDF",className=""}:{storeId:number;label?:string;className?:string}) {
  const [loading,setLoading]=useState(false);
  const [error,setError]=useState("");
  const [download,setDownload]=useState<string|null>(null);
  async function open() {
    if(loading) return;
    setLoading(true);setError("");
    let preview:Window|null=null;
    try {preview=window.open("about:blank","_blank");} catch { /* Offer a direct blob link if popups are blocked. */ }
    if(preview){preview.opener=null;preview.document.body.textContent="Loading agreement PDF…";}
    try {
      const token=localStorage.getItem("ayrshire_token");
      if(!token) throw Error("Please sign in again to view this agreement.");
      const response=await fetch(`/api/sales/merchants/${storeId}/agreement.pdf`,{headers:{Authorization:`Bearer ${token}`},cache:"no-store"});
      if(!response.ok) {
        if(response.status===401) throw Error("Your session has expired. Please sign in again.");
        if(response.status===403) throw Error("You do not have access to this agreement.");
        if(response.status===404) throw Error("No signed agreement is on file yet.");
        throw Error("Could not load the agreement. Please try again.");
      }
      if(!response.headers.get("content-type")?.toLowerCase().includes("application/pdf")) throw Error("The agreement could not be opened as a PDF. Please try again.");
      const url=URL.createObjectURL(await response.blob());
      if(preview && !preview.closed) preview.location.replace(url);
      else setDownload(url);
      setTimeout(()=>{URL.revokeObjectURL(url);setDownload(current=>current===url?null:current);},300000);
    } catch(e) {if(preview && !preview.closed) preview.close();setError(e instanceof Error ? e.message:"Could not load the agreement. Please try again.");}
    finally {setLoading(false);}
  }
  return <span><button type="button" disabled={loading} onClick={()=>void open()} className={className}>{loading ? "Loading PDF…":label}</button>{download && <a href={download} target="_blank" rel="noreferrer" className="block underline text-sm mt-1">Open downloaded agreement PDF</a>}{error && <span role="alert" className="block text-sm text-red-700 mt-1">{error}</span>}</span>;
}
